export default __webpack_public_path__ + "static/media/HV_ClearanceSpecials_WebBanner_CategoryCover_V2.124672d4.jpg";